/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const useCustomCollapsibleFieldStyles = makeStyles((theme: Theme) => ({
  title: {
    color: theme.palette.text.primary,
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: '24px',
  },
  button: {
    backgroundColor: '#F6F7F8',
    borderRadius: '6px',
    width: '100%',
    padding: '10px 20px',
    display: 'flex',
    justifyContent: 'space-between',
    border: '2px solid transparent',

    '&:hover': {
      backgroundColor: '#F6F7F8',
    },
  },
  hasError: {
    backgroundColor: '#fff3f2',
    border: '2px solid #FA634E',

    '&:hover': {
      backgroundColor: '#fff3f2',
    },
  },
  hasWarning: {
    backgroundColor: '#f9f8eb',
    border: '2px solid #fcf6ad',

    '&:hover': {
      backgroundColor: '#f9f8eb',
    },
  },
}));
